import Component, { mixins } from 'vue-class-component';

import { AxiosError, AxiosResponse } from "axios";

import { STORE_ACTIONS } from '@/store';

import { ICountry } from './ICountry.model';

import BaseService from '../../base/Base.service';

@Component
export default class CountryService extends mixins(BaseService) {
  protected service_countryService_fetchCountries(): Promise<Array<ICountry>> {
    return new Promise((resolve: any, reject: any): void => {
      this.$axios.get(`/api/inscriptions-lieu-examen/pays`)
        .then((response: AxiosResponse) => {
          const countries: Array<any> = response.data.data.pays

          this.$store.dispatch(STORE_ACTIONS.COUNTRY_STORE_COUNTRIES, countries)

          resolve(countries)
        }).catch((error: AxiosError) => this.service_base_defaultErrorHandler(error, reject))
    })
  }
}